import api from '../../api/api'
import Vue from 'vue'
import {isDesktop, getProductUrl} from '@/assets/js/common'

const wishlist = {
  state: {
    wishlist: {},
    wishlistItemsIDs: [],
    wishlistCount: 0
  },
  getters: {
    wishlist: state => state.wishlist,
    wishlistItemsIDs: state => state.wishlistItemsIDs,
    wishlistCount: function (state) {
      const localwishlist = Vue.ls.get('tss_token') ? state.wishlist : Vue.ls.get('localwishlist')
      return state.wishlist && state.wishlist.products && state.wishlist.products.items && state.wishlist.products.items.length || localwishlist && localwishlist.products && localwishlist.products.items && Array.isArray(localwishlist.products.items) && localwishlist.products.items.length
    }
  },
  actions: {
    UPDATE_WISHLIST: ({ state, commit, dispatch, getters }, payload) => {
      Vue.toasted.clear()
      const token = Vue.ls.get('tss_token')
      const localwishlist = Vue.ls.get('localwishlist')
      const hideToaster = payload.hideToaster
      delete payload.hideToaster
      const widgetClickPosition = Vue.ls.get('widget_click_position') || {}
      const widgetCurrentRoute = Vue.ls.get('routeObj') || {}

      const updatedPayload = {
        payload: {
          operation: payload.operation,
          type: 'products',
          data: {
            prod_id: payload.data && payload.data.prod_id
          }
        },
        localwishlist
      }

      return api.post(
        'wishlist_new',
        updatedPayload,
        { headers: { Authorization: token }, params: { platform: 'web' } }
      ).then((response) => {
        if (
          response &&
          response.data &&
          response.data.products &&
          response.data.products.items &&
          Array.isArray(response.data.products.items) &&
          response.data.products.items.length === 0
        ) {
          dispatch('CART_WISHLIST_COUNT')
        }

        commit('UPDATE_WISHLIST', { data: response.data, payload })

        switch (updatedPayload.payload.operation) {
          case 'add':
            !hideToaster &&
              Vue.toasted.show('Product Added to your Wishlist', {
                theme: 'primary',
                className: isDesktop() ? 'wishlistADD' : 'toasted-mobileTeal',
                position: isDesktop() ? 'top-right' : 'bottom-right',
                duration: isDesktop() ? 5000 : 2000
              })
            const routeObj = Vue.ls.get('routeObj')
            dispatch('TATVIC_EVENT', {
              eventName: 'gtm.add.to.wishlist',
              payload: {
                product_added_to_cart: updatedPayload.payload,
                coupon_applied: getters.get_coupon_applied,
                coupon_value: getters.calculations.coupon_discount || 0,
                reward_points: getters.calculations.used_reward_points || 0,
                pdp_response: routeObj
              }
            })
            window.snaptr('track', 'ADD_TO_WISHLIST', {
              item_ids: payload.data.prod_id,
              item_category: payload.data.category,
              user_email: getters.user.email,
              user_phone_number: getters.user.telephone,
              uuid_c1: getters.user.userid
            })
            commit('MOENGAGE_EVENT', {
              eventName: 'ADDED_TO_WISHLIST',
              payload: {
                Product_Category: String(payload.data.category),
                Product_Name: String(payload.data.product),
                Product_ID: String(payload.data.parent_prod_id),
                Product_Price: Number(
                  payload.data.spl_price ||
                  (payload.data.exclusivePrice ? payload.data.exclusivePrice : payload.data.price)
                ),
                Quantity: Number(payload.data.quantity),
                Product_Artist: String(payload.data.prArtist),
                Product_URL: String(getProductUrl(true, payload.data.url_key, payload.data.gender_type)),
                ProductImage_URL: String(
                  process.env.IMG_BASE_URL +
                  process.env.PRODUCT_DETAIL_IMG +
                  (payload.data.images && payload.data.images[0])
                ),
                Source: String(routeObj && routeObj.previous),
                Platform: 'WEB',
                widget_name: widgetClickPosition && widgetClickPosition.name ? widgetClickPosition.name.toLowerCase() : '',
                widget_click_position: widgetClickPosition && widgetClickPosition.route,
                widget_current_route: widgetCurrentRoute.current
              }
            })
            let image = (payload && payload.data && Array.isArray(payload.data.images) && payload.data.images[0]) ? process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG + payload.data.images[0] : 'NA'
            let productUrl = (payload && payload.data && payload.data.url_key && payload.data.gender_type) ? getProductUrl(true, payload.data.url_key, payload.data.gender_type) : 'NA'
            let variantId = (payload && payload.data.size && Array.isArray(payload && payload.data.variant)) ? ((payload.data.variant.find(v => v.size === payload.data.size) || {}).id || 'NA') : 'NA'
            commit('GTM_EVENT', {
              eventName: 'add_to_wishlist',
              payload: {
                currency: 'INR',
                value: payload.data.spl_price || payload.data.exclusivePrice ? this.isExclusive ? payload.data.exclusivePrice : payload.data.spl_price : payload.data.price || 0,
                items: [{
                  product_url: productUrl,
                  image: image,
                  membership_price: payload && payload.data && payload.data.spl_price ? payload.data.spl_price : 0,
                  stock_availability: payload && payload.data && Number(payload.data.prod_qty) && Number(payload.data.prod_qty) > 1 ? 1 : 0,
                  artist_name: payload && payload.data && payload.data.prArtist ? payload.data.prArtist.replace('\u0099', '') : '',
                  variant_id: variantId,
                  item_id: payload && payload.data && payload.data.prod_id ? String(payload.data.prod_id) : '',
                  item_name: payload.data.product,
                  item_category: payload.data.category,
                  price: payload && payload.data && payload.data.price ? payload.data.price : 0,
                  quantity: payload.data.quantity || 1,
                  discount: payload && payload.data && payload.data.spl_price ? payload.data.spl_price : 0,
                  affiliation: 'The Souled Store',
                  item_brand: 'The Souled Store'
                }]
              }
            })
            commit('VINSENZE_EVENT', {
              eventName: 'add_to_wishlist',
              payload: {
                pid: String(payload.data.parent_prod_id),
                imUrl: String(
                  process.env.IMG_BASE_URL +
                  process.env.PRODUCT_DETAIL_IMG +
                  (payload.data.images && payload.data.images[0])
                ),
                queryId: localStorage.getItem('visenze_queryId') || 'none'
              }
            })
            break
          case 'delete':
            !hideToaster &&
              Vue.toasted.show('Product removed from your Wishlist', {
                theme: 'primary',
                className: isDesktop() ? 'wishlistADD' : 'toasted-mobileTeal',
                position: isDesktop() ? 'top-right' : 'bottom-right',
                duration: isDesktop() ? 5000 : 2000
              })
            commit('GTAG_EVENT', {
              eventName: 'product.remove_from_wishlist',
              payload: {
                product_remove_from_cart: updatedPayload.payload,
                pdp_response: Vue.ls.get('routeObj')
              }
            })
            dispatch('TATVIC_EVENT', {
              eventName: 'REMOVE_FROM_WISHLIST',
              payload: {
                PRODUCT_NAME: updatedPayload.payload.data.product || 'NA',
                PARENT_SKU: updatedPayload.payload.data.prod_id || 'NA',
                PRODUCT_CATEGORY: updatedPayload.payload.data.category || 'NA',
                ARTIST_NAME: updatedPayload.payload.data.artist || 'NA',
                PRODUCT_TAG: updatedPayload.payload.data.category || 'NA'
              }
            })
            break
          default:
            console.log('DEFAULT CASE TRIGGERED')
        }
        return response
      }).catch(error => {
        if (error && error.data) {
          Vue.toasted.show(error.data.title || error.data.message, {
            theme: 'primary',
            className: 'toasted-customred',
            position: 'top-right',
            duration: 5000
          })
        }
      })
    },
    WISHLIST_DATA: ({commit}, payload) => {
      const token = Vue.ls.get('tss_token')
      const localwishlist = Vue.ls.get('localwishlist')
      let params = {
        platform: 'web'
      }
      if (payload && payload.isReinit) {
        params = {
          ...params,
          re_init: payload.isReinit
        }
      }
      return api.post('wishlist_new', {
        payload: {operation: 'get', type: 'products'},
        localwishlist,
        is_ab_visible: true
      }, {headers: {'Authorization': token}, params}).then((response) => {
        commit('WISHLIST_DATA', response.data)
        return response.data
      }).catch(error => {
        console.log(error)
      })
    },
    WISHLIST_VARIANTS: ({commit}, payload) => {
      const token = Vue.ls.get('tss_token')
      let params = { platform: 'web' }

      const prodId = payload.prod_id

      return api.get(`variants/${prodId}`, {
        payload: { operation: 'get', type: 'variants' }
      }, { headers: { 'Authorization': token }, params })
        .then((response) => {
          commit('WISHLIST_VARIANTS', response.data)
          return response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    GET_WISHLIST_IDS: ({ commit, state }, payload) => {
      const data = Vue.ls.get('localwishlist')
      const wishlistIds = {}

      if (data && data.products && data.products.items) {
        data.products.items.forEach(item => {
          wishlistIds[item.parent_prod_id] = true
        })
      }
      commit('GET_WISHLIST_IDS', wishlistIds)
    }
  },
  mutations: {
    WISHLIST_DATA: (state, data) => {
      Vue.ls.set('localwishlist', data)
      state.wishlist = data
      const wishlistIds = {}
      data && data.products && data.products.items && data.products.items.forEach(item => {
        wishlistIds[item.parent_prod_id] = true
      })
      state.wishlistItemsIDs = {...wishlistIds}
    },
    UPDATE_WISHLIST: (state, {data, payload}) => {
      Vue.ls.set('localwishlist', data)
      state.wishlist = data
      if (state.wishlistItemsIDs && payload.data && payload.data.parent_prod_id) {
        let wishlistIds = {...state.wishlistItemsIDs}
        if (wishlistIds[payload.data.parent_prod_id]) {
          wishlistIds = {
            ...wishlistIds,
            [payload.data.parent_prod_id]: false
          }
        } else {
          wishlistIds = {
            ...wishlistIds,
            [payload.data.parent_prod_id]: true
          }
        }
        state.wishlistItemsIDs = {...wishlistIds}
      }
    },
    WISHLIST_VARIANTS: (state, data) => {
      // Normalize → always end up with an array
      const items = Array.isArray(data) ? data : (data && data.items) ? data.items : (data && data.variant) ? data.variant : []
      // Save in local storage
      Vue.ls.set('wishlistVariants', items)

      // Store in state
      state.wishlistVariants = items

      // Prepare a quick lookup map of variant IDs
      const variantIds = {}
      items.forEach(item => {
        variantIds[item.id || item.prod_id] = true
      })

      state.wishlistVariantIDs = { ...variantIds }
    },
    GET_WISHLIST_IDS: (state, data) => {
      state.wishlistItemsIDs = {...data}
    }
  }
}

export default wishlist



// WEBPACK FOOTER //
// ./src/store/modules/wishlist.js